module.exports = __webpack_public_path__ + "img/promotionTraining1.5c28b294.jpg";